interface OtherIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const OtherIcon = (props: OtherIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path style={{ fill: fillColor }} d="M14.21,15.86H25.79v1.65h.83V15.45a.41.41,0,0,0-.41-.41H13.79a.41.41,0,0,0-.41.41v2.07h.83ZM15,12.55H25v1.65h.83V12.14a.41.41,0,0,0-.41-.41H14.62a.41.41,0,0,0-.41.41v2.07H15Zm11.58,8.27h.83V18.76a.41.41,0,0,0-.41-.41H13a.41.41,0,0,0-.41.41v2.07h.83V19.17H26.62ZM31.56,22h0L28.26,9.55h0a.41.41,0,0,0-.39-.31H12.14a.41.41,0,0,0-.39.31h0L8.43,22h0a.41.41,0,0,0,0,.1v8.27a.41.41,0,0,0,.41.41H31.17a.41.41,0,0,0,.41-.41V22.07A.41.41,0,0,0,31.56,22ZM12.46,10.07H27.54l3.09,11.58H25.38c-2.07,0-2.48,3.31-3.31,3.31H17.93c-.83,0-1.24-3.31-3.31-3.31H9.37Zm18.3,19.86H9.24V22.48h5.38c1.65,0,1.65,3.31,3.31,3.31h4.14c1.65,0,1.65-3.31,3.31-3.31h5.38Z" />
    </svg>
  )
}

export default OtherIcon
